import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { File } from '@phrasewright/types';

export interface FilesState {
  files: File[];
  selectedFileId: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: FilesState = {
  files: [],
  selectedFileId: null,
  loading: false,
  error: null,
};

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setFiles: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload;
      state.error = null;
    },
    addFile: (state, action: PayloadAction<File>) => {
      state.files.push(action.payload);
    },
    updateFile: (state, action: PayloadAction<File>) => {
      const index = state.files.findIndex((f) => f.id === action.payload.id);
      if (index !== -1) {
        state.files[index] = action.payload;
      }
    },
    deleteFile: (state, action: PayloadAction<string>) => {
      state.files = state.files.filter((f) => f.id !== action.payload);
      if (state.selectedFileId === action.payload) {
        state.selectedFileId = null;
      }
    },
    selectFile: (state, action: PayloadAction<string | null>) => {
      state.selectedFileId = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setFiles,
  addFile,
  updateFile,
  deleteFile,
  selectFile,
  setLoading,
  setError,
} = filesSlice.actions;

export const filesReducer = filesSlice.reducer;
